<i18n src="./resources/crm/contact-locales.json"></i18n>

<template>
  <v-menu
    :value="show"
    :position-x="position.x"
    :position-y="position.y"
    absolute
    :z-index="1000"
    :close-on-click="false"
    :close-on-content-click="false"
  >
    <v-card
      v-if="contact"
      color="surface lighten-1"
      :width="314"
      @mouseenter.stop="keepOpen"
      @mouseleave.stop="syncClose"
    >
      <v-list color="surface lighten-1">
        <v-list-item>
          <div class="crm-contact-avatar">
            <EcsAvatar :contact-id="contact.id" :alt="contact.name" :size="60" no-animation />
          </div>
          <v-list-item-content>
            <v-list-item-title>{{ contact.name }} </v-list-item-title>
            <v-list-item-subtitle v-if="contact.phones.length">
              <v-icon small left>mdi-phone</v-icon>{{ contact.phones[0].value }}
            </v-list-item-subtitle>
            <v-list-item-subtitle v-if="contact.emails.length">
              <v-icon small left>mdi-email</v-icon>{{ contact.emails[0].value }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn icon @click.stop="showContactExpandedDetails = !showContactExpandedDetails">
              <v-icon>
                {{ expantedDetailsIcon }}
              </v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
      <v-expand-transition>
        <div v-show="showContactExpandedDetails" class="crm-contact-expanded-view-container">
          <v-divider></v-divider>
          <div class="crm-contact-expanded-view custom-scrollbar">
            <div v-for="(field, index) in crmTemplate" :key="index" class="crm-contact-info">
              <div class="font-weigth-medium">{{ field.label }}</div>
              <div>{{ contact[field.name] || '-' }}</div>
            </div>
          </div>
        </div>
      </v-expand-transition>
    </v-card>
  </v-menu>
</template>

<script>
import EcsAvatar from '@/components/ecs-base-interaction-components/ecs-avatar/EcsAvatar';

export default {
  name: 'EcsCrmContactCardSingleton',

  components: { EcsAvatar },

  data() {
    return {
      show: false,
      position: {
        x: null,
        y: null
      },
      closeTimeoutRef: null,
      contact: null,
      showContactExpandedDetails: false,
      crmTemplate: [
        {
          name: 'firstName',
          label: 'First name'
        },
        {
          name: 'lastName',
          label: 'Last name'
        },
        {
          name: 'email',
          label: 'E-mail'
        },
        {
          name: 'company',
          label: 'Company'
        }
      ]
    };
  },

  computed: {
    expantedDetailsIcon() {
      return this.showContactExpandedDetails ? 'mdi-chevron-up' : 'mdi-chevron-down';
    }
  },

  created() {
    this.$root.$on('open-crm-contact-card', this.open);
    this.$root.$on('close-crm-contact-card', this.close);
  },

  beforeDestroy() {
    this.$root.$off('open-crm-contact-card', this.open);
    this.$root.$off('close-crm-contact-card', this.close);
  },

  methods: {
    keepOpen() {
      clearTimeout(this.closeTimeoutRef);
    },

    open({ contact, crmTemplate, x, y }) {
      this.contact = contact;
      this.crmTemplate = crmTemplate || this.crmTemplate;
      this.position.x = x;
      this.position.y = y;
      this.show = true;
      clearTimeout(this.closeTimeoutRef);
    },

    syncClose() {
      clearTimeout(this.closeTimeoutRef);
      this.contact = null;
      this.show = false;
    },

    close() {
      this.closeTimeoutRef = setTimeout(() => {
        this.contact = null;
        this.show = false;
      }, 300);
    }
  }
};
</script>

<style lang="scss" scoped>
.crm-contact-avatar {
  margin-right: 10px;
}

.crm-contact-expanded-view-container {
  padding-bottom: 8px;
}

.crm-contact-expanded-view {
  height: 168px;
}

.crm-contact-info {
  display: grid;
  grid-template-columns: 108px calc(100% - 108px);
  width: 100%;
  font-size: 12px;
  line-height: 12px;
  grid-column-gap: 8px;
  padding: 0 16px 4px 16px;
}

.crm-contact-info:first-child {
  padding-top: 8px;
}
</style>
